<template>
<b-card>
  <div class="card-header">
    <ul class="nav nav-pills card-header-pills">

      <li class="nav-item">
        <a class="nav-link disabled">Log History</a>
      </li>
      <li class="nav-item">
        <b-button type="button" variant="primary" class="float-right" @click="refreshHistory()" style="background-color:orange !important; color:#fff;">
          <i class="icon-refresh" style="background-color:orange; color:#fff;"></i>
        </b-button>
      </li>
    </ul>
  </div>

  <b-table responsive="sm" :items="histories" :fields="fields" :current-page="currentPage" :per-page="perPage" :filter="filter">
    <template slot="recordType" slot-scope="data">
          {{recordsTypes[data.item.recordType]}}
        </template>
    <template slot="success" slot-scope="data">
          <p class="text-success" v-if="data.item.success === 1">{{isSuccess[data.item.success]}}</p>
          <p class="text-danger" v-if="data.item.success === 0">{{isSuccess[data.item.success]}}</p>
        </template>
  </b-table>
  <nav>
    <b-pagination :total-rows="getRowCount(histories)" :per-page="perPage" v-model="currentPage" prev-text="Prev" next-text="Next" hide-goto-end-buttons/>
  </nav>
</b-card>
</template>

<script>
let qs = require('qs')
const constants = require('../shared/constants')
const BASE = constants.NEWPORT_CONST.API_URL
const API = BASE + '/api/histories/list'
const API_HUB_SEND = BASE + '/api/hubs/send'
var dateOptions = {
  weekday: 'short',
  day: 'numeric',
  month: 'short',
  year: 'numeric',
  hour: 'numeric',
  minute: 'numeric',
  second: 'numeric'
}

function postdata (url, data) {
  return fetch(url, {
    body: qs.stringify(data),
    headers: {
      'content-type': 'application/x-www-form-urlencoded',
      'accessToken': data.accessToken,
      'authorization': data.accessToken
    },
    method: 'POST'
  }).then(res => res.json())
}

async function getData (lockId) {
  let paramsHub = {
    client_id: constants.NEWPORT_CONST.CLIENT_ID,
    client_secret: constants.NEWPORT_CONST.CLIENT_SECRET,
    accessToken: localStorage.getItem('token'),
    lockId: lockId,
    command: 'syncHistory'
  }
  let parameters = {
    client_id: constants.NEWPORT_CONST.CLIENT_ID,
    client_secret: constants.NEWPORT_CONST.CLIENT_SECRET,
    accessToken: localStorage.getItem('token'),
    lockId: lockId,
    startDate: 0,
    endDate: 0,
    pageSize: 25
  }
  postdata(API_HUB_SEND, paramsHub)
  let res = await postdata(API, parameters)
  let result = res.list
  return result
}

export default {
  name: 'history-list',

  data: () => {
    return {
      histories: [],
      isSuccess: ['Failed', 'Success'],
      recordsTypes: [
        '-',
        'App unlock', // 1
        'Touch the parking lock', // 2
        'Gateway unlock', // 3
        'Passcode unlock', // 4
        'Parking lock raise', // 5
        'Parking lock lower', // 6
        'IC card unlock', // 7
        'Fingerprint unlock', // 8
        'Wristband unlock', // 9
        'Mechanical key unlock', // 10
        'Bluetooth lock', // 11
        'Gateway unlock', // 12
        '13',
        '14',
        '15',
        '16',
        '17',
        '18',
        '19',
        '20',
        '21',
        '22',
        '23',
        '24',
        '25',
        '26', // lock
        '27',
        '28',
        'Unexpected unlock',
        'Door magnet close',
        'Door magnet open'
      ],
      fields: {
        fullName: {
          label: 'Who'
        },
        recordType: {
          label: 'Action'
        },
        lockDate: {
          label: 'When',
          formatter: (value, key, item) => {
            return (new Date(item.lockDate)).toLocaleString('en-GB', dateOptions)
          }
        },
        success: {
          label: 'Operation'
        }
      },
      currentPage: 1,
      perPage: 50,
      totalRows: 0,
      filter: null
    }
  },
  mounted () {
    getData(this.$route.params.lockId).then(response => {
      this.$data.histories = response
    })
  },
  methods: {
    mailto (email) {
      return 'mailto:' + email
    },
    getRowCount (items) {
      return items.length
    },
    openlink (link) {
      location.href = link
    },
    refreshHistory () {
      getData(this.$route.params.lockId).then(response => {
        this.$data.histories = response
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/base/haus/HistoryList.vue